import { getButtonFontProperties } from 'client/pages/contact-us/entities/contact-us-button'
import { GoogleFontProperties } from 'common/utils/fontsUtils'
import { FormInterface } from 'src/shared/types/entities/form-interface'
import { GoogleFontsGenerator } from 'src/shared/utils/google-fonts-generator'

export function getFormFontProperties(entity: FormInterface) {
  const fontProperties: GoogleFontProperties[] = []

  fontProperties.push(...getButtonFontProperties(entity.buttonCommonStyles))
  fontProperties.push(
    ...GoogleFontsGenerator.getBaseTextEntityFontVariants(
      entity.checkboxesCommonStyles,
    ),
  )

  return fontProperties
}
